import Lenis from './helpers/Lenis.js';

import ScrollObject from './components/core/ScrollObject'
import SplitText from './components/core/SplitText'
import CoreTabs from './components/core/CoreTabs'
import CoreSlideshow from './components/core/CoreSlideshow'

import AppHeader from './components/AppHeader.js'
import WebApplication from './components/WebApplication'

import BackgroundFade from './components/BackgroundFade.js'
import LazyLoading from './components/LazyLoading.js'
import AppDropdown from './components/AppDropdown'
import AppSearch from './components/AppSearch';
import ScrollExpand from './components/ScrollExpand';
import ScrollScale from './components/ScrollScale';

import BlockStores from './components/blocks/BlockStores.js'
import BlockHome from './components/blocks/BlockHome.js'
import BlockChart from './components/blocks/BlockChart.js'
import AuthorsBrowser from './components/AuthorsBrowser.js'
import AppFilter from './components/AppFilter.js'
import NewsletterForm from './components/NewsletterForm.js'
import NewsletterOverlay from './components/NewsletterOverlay.js'

// ––––––––––––––––––––––––––––––––––––– 
console.log('Humanist Review – v0.0.1');
// –––––––––––––––––––––––––––––––––––––

// Fix UHF WCAG issue
if (document.readyState === 'complete') {
  onReady()
}
else {
  window.addEventListener("DOMContentLoaded", onReady );
}

function onReady() {
  document.querySelectorAll('.uhf-skip-link')?.forEach(el => {
    el.parentNode.removeChild(el);
  });
}